export default __webpack_public_path__ + "static/media/oprah_winfrey.92eed84b.png";